import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as orgActions from "../../actions/organization";
import * as appUsersActions from "../../actions/appusers";

import sort from "fast-sort";

import AppFrame from "../Appframe/AppFrame";
import Title from "../../components/common/Title";
import layout from "../../styles/layout";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Button,
  FormControlLabel,
  Switch,
  TextField,
} from "@material-ui/core";

import colors from "../../styles/colors";
import "../../styles/page/orgClients.css";
import AddPatient from "../../components/common/AddPatient";
import organizationService from "../../services/organization";
import Loader from "react-loader-advanced";
import events from "../../services/events";
import "../../resources/styles/ManageUsers.css";

const ManageOrgClients = (props) => {
  const [nameFilter, setNameFilter] = useState("");
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDropDownValue, setSelectedDropDownValue] = useState(-1);
  const [selectedChannel, setSelectedChannel] = useState(-1);
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedChannelProvider, setSelectedChannelProvider] = useState("");
  const [selectedChannelProviderUserId, setSelectedChannelProviderUserId] =
    useState(-1);

  const [newProviderValue, setNewProviderValue] = useState(-1);
  const [newProviderChannel, setNewProviderChannel] = useState(-1);
  const [nweProvider, setNewProvider] = useState("");
  const [newProviderUserId, setNewProviderUserId] = useState(-1);
  const [selectedIdx, setSelectedIdx] = useState(-1);
  const [isDischargeOpen, setIsDischargeOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isMoveOpen, setIsMoveOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [dischargedCount, setDischargedCount] = useState(0);
  const [removedCount, setRemovedCount] = useState(0);
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    if (selectedChannel !== -1 && inviteOpen === false) {
      setIsLoading(true);
      organizationService()
        .getClientsForOrganizationApp(
          props.user.userId,
          selectedChannel,
          props.organization.orgId
        )
        .then((resp) => {
          let activeCount = 0;
          let dischargedCount = 0;
          let removedCount = 0;
          resp.users.map((user) => {
            if (user.hasAccess && !user.isDischarged) {
              activeCount++;
            } else if (user.isDischarged && user.hasAccess) {
              dischargedCount++;
            } else {
              removedCount++;
            }
          });
          setActiveCount(activeCount);
          setDischargedCount(dischargedCount);
          setTotalCount(resp.users.length);
          setRemovedCount(removedCount);
          setData(resp.users);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedChannel, inviteOpen]);

  const getData = () => {
    return sort(data)
      .asc([(r) => r.userInfo.lastName, (r) => r.userInfo.firstName])
      .filter((r) => {
        return showAll ? true : r.hasAccess;
      })
      .filter((r) => {
        if (nameFilter !== "") {
          return (r.userInfo.firstName + " " + r.userInfo.lastName)
            .toLowerCase()
            .includes(nameFilter.toLowerCase());
        } else {
          return true;
        }
      });
  };

  const generateTable = () => {
    return getData().map((r, idx) => {
      return (
        <tr
          style={{
            paddingTop: 50,
            paddingBottom: 50,
          }}
        >
          <td style={{ textAlign: "center" }}>
            <div
              className="user_avatar"
              style={{
                backgroundImage: `url(${r.userInfo.profilePhotoUrl})`,
              }}
            ></div>
          </td>
          <td
            style={{
              minWidth: 275,
              color: r.isDischarged ? "#878787" : "black",
            }}
          >
            {r.userInfo.firstName + " " + r.userInfo.lastName}
          </td>
          <td
            style={{
              color: r.isDischarged ? "#878787" : "black",
            }}
          >
            {r.userInfo.email}
          </td>
          <td
            style={{
              minWidth: 150,
              color: r.isDischarged ? "#878787" : "black",
            }}
          >
            {r.dateOfEval}
          </td>
          <td style={{ color: r.isDischarged ? "#878787" : "black" }}>
            {r.isDischarged
              ? r.hasAccess
                ? "Discharged"
                : "Removed"
              : "Active"}
          </td>
          <td style={{ minWidth: 250 }}>
            <Button
              onClick={() => {
                setIsMoveOpen(true);
                setSelectedClient(r);
                setSelectedIdx(idx);
              }}
              color="primary"
              variant="outlined"
              style={{ marginBottom: 10 }}
            >
              Reassign
            </Button>
            {!r.isDischarged && (
              <Button
                onClick={() => {
                  setIsDischargeOpen(true);
                  setSelectedClient(r);
                  setSelectedIdx(idx);
                }}
                color="primary"
                variant="outlined"
                style={{ marginLeft: 5, marginBottom: 10 }}
              >
                Discharge
              </Button>
            )}
            {r.isDischarged && (
              <Button
                onClick={() => {
                  setIsActivateOpen(true);
                  setSelectedClient(r);
                  setSelectedIdx(idx);
                }}
                color="primary"
                variant="outlined"
                style={{ marginLeft: 5, marginBottom: 10 }}
              >
                Activate
              </Button>
            )}
            {r.hasAccess && (
              <Button
                onClick={() => {
                  setIsRemoveOpen(true);
                  setSelectedClient(r);
                  setSelectedIdx(idx);
                }}
                variant="outlined"
                style={{
                  color: "red",
                  borderColor: "red",
                  marginLeft: 5,
                  marginBottom: 10,
                }}
              >
                Remove
              </Button>
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <AppFrame
      auth={props.auth}
      header="Manage Organization Patient/Clients"
      optionsType="organizationClients"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <div style={layout.common.page}>
        <Loader show={isLoading} message={"Loading..."} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <FormControl>
              <InputLabel style={{ fontSize: 16 }}>Provider</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedDropDownValue}
                onChange={(event) => {
                  setSelectedDropDownValue(event.target.value);
                  let vals = event.target.value.split("_");
                  setSelectedChannel(vals[0]);
                  setSelectedChannelProvider(vals[1]);
                  setSelectedChannelProviderUserId(vals[2]);
                  setSelectedChannelName(vals[3]);
                }}
                fullWidth={true}
                autoWidth={true}
                style={{ width: 900 }}
              >
                {props.organization &&
                  sort(props.organization.orgChannels)
                    .asc([(r) => r.providerName])
                    .map((oc) => {
                      return (
                        <MenuItem
                          value={
                            oc.appId +
                            "_" +
                            oc.providerName +
                            "_" +
                            oc.providerUserId +
                            "_" +
                            oc.channelName
                          }
                        >
                          {oc.providerName}
                        </MenuItem>
                      );
                    })}
              </Select>
              <FormHelperText style={{ fontSize: 16 }}>
                {selectedChannel === -1 && "Please select a provider to begin"}
              </FormHelperText>
            </FormControl>
          </div>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1>Patients/Clients List</h1>
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showAll}
                      onChange={(val) => {
                        setShowAll(!showAll);
                      }}
                      name="toggleAll"
                      color="primary"
                    />
                  }
                  label="Show All"
                />
                <Button
                  onClick={() => {
                    setInviteOpen(true);
                  }}
                  color="primary"
                  variant="outlined"
                  style={{
                    backgroundColor:
                      selectedChannel === -1 ? "#CECECE" : colors.primary,
                    color: selectedChannel === -1 ? "#878787" : colors.white,
                  }}
                  disabled={selectedChannel === -1}
                >
                  Add New Patient/Client
                </Button>
              </div>
            </div>
            {data.length > 0 && selectedChannel !== -1 && !isLoading && (
              <div className="manage_user_counts_row">
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">{activeCount}</h2>
                  Active Patients
                </div>
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">
                    {dischargedCount}
                  </h2>
                  Discharged Patients
                </div>
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">{totalCount}</h2>
                  Total Patients
                </div>
              </div>
            )}
            <div style={{ margin: 20, minWidth: 1050 }}>
              {selectedChannel === -1 && <p>Provider not selected...</p>}
              {data.length === 0 && selectedChannel !== -1 && !isLoading && (
                <h3>No Patients/Clients To Display</h3>
              )}
              {data.length > 0 && selectedChannel !== -1 && !isLoading && (
                <TextField
                  type="search"
                  fullWidth
                  variant="outlined"
                  helperText="Enter name of patient/client to filter the list below"
                  label="Search by Patient/Client Name"
                  style={{ marginBottom: 0 }}
                  value={nameFilter}
                  onChange={(event) => {
                    setNameFilter(event.target.value);
                  }}
                />
              )}

              {data.length > 0 && selectedChannel !== -1 && !isLoading && (
                <Paper style={{ padding: 10, marginTop: 0 }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "seperate",
                    }}
                  >
                    <tr
                      style={{
                        borderBottom: "solid 3px orange",
                        marginBottom: 5,
                        fontSize: 18,
                        color: colors.accent,
                      }}
                    >
                      <th></th>
                      <th>Name</th>
                      <th>Email</th>
                      <th style={{ width: 150 }}>Date Of Eval</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>

                    {selectedChannel !== -1 && generateTable()}
                  </table>
                </Paper>
              )}
            </div>
          </div>
        </div>

        <Dialog
          open={isDischargeOpen}
          onClose={() => {
            setIsDischargeOpen(false);
          }}
        >
          <DialogContent>
            <h3 style={{ color: colors.primary, margin: 0 }}>
              Discharge Patient/Client
            </h3>
            <hr />
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              Are you sure you want to discharge{" "}
              {selectedClient !== null && (
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {selectedClient.name}
                </span>
              )}
              ?
            </div>
            <div style={{ color: "#808080" }}>
              Note: Discharging a client will remove the client from your active
              list but still allow your client to access their careplan.
            </div>
            <DialogActions>
              <DialogActions>
                <Button
                  onClick={() => {
                    setIsDischargeOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const tmpData = getData();
                    let user = tmpData[selectedIdx];

                    props.dischargeAppUser(
                      props.user.userId,
                      selectedChannel,
                      user.userId
                    );

                    events().trackUserEvent(
                      "Discharge User",
                      selectedChannel,
                      null,
                      null,
                      null,
                      props.user.userId,
                      user.userId,
                      "portal",
                      selectedChannelName,
                      null,
                      JSON.stringify({ orgLevel: true })
                    );

                    let updatedData = tmpData;
                    updatedData[selectedIdx].isDischarged = true;
                    setData(updatedData);
                    setIsDischargeOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  color="primary"
                  variant="outlined"
                  style={{
                    backgroundColor: colors.primary,
                    color: colors.white,
                  }}
                >
                  Discharge
                </Button>
              </DialogActions>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isActivateOpen}
          onClose={() => {
            setIsActivateOpen(false);
          }}
        >
          <DialogContent>
            <h3 style={{ color: colors.primary, margin: 0 }}>
              Activate Client
            </h3>
            <hr />
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              Are you sure you want to activate{" "}
              {selectedClient !== null && (
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {selectedClient.name}
                </span>
              )}
              ?
            </div>
            <DialogActions>
              <DialogActions>
                <Button
                  onClick={() => {
                    setIsActivateOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const tmpData = getData();
                    let user = tmpData[selectedIdx];

                    props.enrollAppUser(
                      selectedChannel,
                      user.userId //PatientId
                    );

                    events().trackUserEvent(
                      "Activate User",
                      selectedChannel,
                      null,
                      null,
                      null,
                      props.user.userId,
                      user.userId,
                      "portal",
                      selectedChannelName,
                      null,
                      JSON.stringify({ orgLevel: true })
                    );

                    let updatedData = tmpData;
                    updatedData[selectedIdx].isDischarged = false;
                    updatedData[selectedIdx].hasAccess = true;
                    setData(updatedData);
                    setIsActivateOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  color="primary"
                  variant="outlined"
                  style={{
                    backgroundColor: colors.primary,
                    color: colors.white,
                  }}
                >
                  Activate
                </Button>
              </DialogActions>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isRemoveOpen}
          onClose={() => {
            setIsRemoveOpen(false);
          }}
        >
          <DialogContent>
            <h3 style={{ color: "red", margin: 0 }}>Remove Patient/Client</h3>
            <hr />
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              Are you sure you want to remove{" "}
              {selectedClient !== null && (
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {selectedClient.name}
                </span>
              )}
              ?
            </div>
            <div style={{ color: "#808080" }}>
              Note: Removing a client will remove the client from your active
              and remove access from the client.
            </div>
            <DialogActions>
              <DialogActions>
                <Button
                  onClick={() => {
                    setIsRemoveOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const tmpData = getData();
                    let user = tmpData[selectedIdx];

                    props.dischargeAppUserNoAccess(
                      props.user.userId,
                      selectedChannel,
                      user.userId //PatientId
                    );

                    events().trackUserEvent(
                      "Remove User",
                      selectedChannel,
                      null,
                      null,
                      null,
                      props.user.userId,
                      user.userId,
                      "portal",
                      selectedChannelName,
                      null,
                      JSON.stringify({ orgLevel: true })
                    );

                    let updatedData = tmpData;
                    updatedData[selectedIdx].isDischarged = true;
                    updatedData[selectedIdx].hasAccess = false;
                    setData(updatedData);
                    setIsRemoveOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  color="primary"
                  variant="outlined"
                  style={{
                    backgroundColor: "red",
                    color: colors.white,
                  }}
                >
                  Remove
                </Button>
              </DialogActions>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isMoveOpen}
          onClose={() => {
            setIsMoveOpen(false);
          }}
        >
          <DialogContent>
            <h3 style={{ color: colors.primary, margin: 0 }}>
              Reassign Patient/Client
            </h3>
            <p>Please select the new provider below</p>
            <FormControl>
              <InputLabel style={{ fontSize: 16 }}>New Provider</InputLabel>
              <Select
                labelId="changeToProvider"
                id="changeToProvider"
                value={newProviderValue}
                onChange={(event) => {
                  setNewProviderValue(event.target.value);
                  let vals = event.target.value.split("_");
                  setNewProviderChannel(vals[0]);
                  setNewProvider(vals[1]);
                  setNewProviderUserId(vals[2]);
                }}
                fullWidth={true}
                autoWidth={true}
                style={{ width: 300 }}
              >
                {props.organization &&
                  sort(props.organization.orgChannels)
                    .asc([(r) => r.providerName])
                    .map((oc) => {
                      return (
                        <MenuItem
                          value={
                            oc.appId +
                            "_" +
                            oc.providerName +
                            "_" +
                            oc.providerUserId
                          }
                        >
                          {oc.providerName}
                        </MenuItem>
                      );
                    })}
              </Select>
            </FormControl>
            <DialogActions>
              <DialogActions>
                <Button
                  onClick={() => {
                    setIsMoveOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const tmpData = getData();
                    let user = tmpData[selectedIdx];

                    props.moveCustomAppToNewChannel(
                      props.user.userId,
                      user.customAppId,
                      user.userId,
                      newProviderChannel //PatientId
                    );

                    tmpData.splice(selectedIdx, 1);
                    setData(tmpData);

                    setIsMoveOpen(false);
                    setSelectedClient(null);
                    setSelectedIdx(-1);
                    setNewProvider("");
                    setNewProviderValue(-1);
                    setNewProviderUserId(-1);
                    setNewProviderChannel(-1);
                  }}
                  color="primary"
                  variant="outlined"
                >
                  Reassign
                </Button>
              </DialogActions>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <AddPatient
          open={inviteOpen}
          appId={selectedChannel}
          userId={selectedChannelProviderUserId}
          appName={selectedChannelName}
          title={selectedChannelProvider}
          isLibOnly={false}
          close={() => setInviteOpen(false)}
        />
      </div>
    </AppFrame>
  );
};

function mapStateToProps({ user, organization, whiteLabelSettings }) {
  return { user, organization, whiteLabelSettings };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...orgActions, ...appUsersActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageOrgClients);



// WEBPACK FOOTER //
// ./src/layout/organization/ManageOrgClients.js